import { useIntl } from "react-intl";
import { useRouter } from "next/router";
import { AlertIcon } from "@/public/icons/AlertIcon";
import { CheckmarkIcon } from "@/public/icons/CheckmarkIcon";
import { routes } from "@/routes/routes";
import styles from "./CustomerCard.module.scss";
type CustomerCardProps = {
  isDocumentsMissing: boolean;
  label: string;
  slug: string;
  cacheId: string | undefined;
  name: string;
  type: string;
};

export const CustomerCard = ({
  isDocumentsMissing,
  slug,
  name,
  cacheId,
  type,
  label,
}: CustomerCardProps) => {
  const intl = useIntl();
  const router = useRouter();

  const addDocuments = () => {
    const returnUrl = `/check-in/${slug}`;
    if (cacheId !== undefined) {
      if (slug === "email") {
        const queryParams = new URLSearchParams(router.asPath.split("?")[1]);
        const email = queryParams.get("email") as string;
        const bookingId = queryParams.get("reservationId") as string;
        void router.push(
          `${routes.addDocuments(cacheId)}?returnUrl=${encodeURIComponent(
            returnUrl
          )}&name=${encodeURIComponent(name)}&type=${encodeURIComponent(
            type
          )}&email=${encodeURIComponent(
            email
          )}&reservationId=${encodeURIComponent(bookingId)}`
        );
      } else {
        void router.push(
          `${routes.addDocuments(cacheId)}?returnUrl=${encodeURIComponent(
            returnUrl
          )}&name=${encodeURIComponent(name)}&type=${encodeURIComponent(type)}`
        );
      }
    } else {
      void router.push(
        `${routes.addDriver}?returnUrl=${encodeURIComponent(
          returnUrl
        )}&name=${encodeURIComponent(name)}&type=${encodeURIComponent(type)}&`
      );
    }
  };

  return (
    <div className={styles.card}>
      <div className={styles.label}>{label}</div>
      <div className={styles.description}>{name}</div>
      {isDocumentsMissing ? (
        <div className={styles.action} onClick={addDocuments}>
          <span className={styles.alertIcon}>
            <AlertIcon />
          </span>
          {intl.formatMessage({ id: "documentsNotSent" })}
        </div>
      ) : (
        <div className={styles.noAction}>
          <CheckmarkIcon size="20" color={"#27b18f"} />
          {intl.formatMessage({ id: "documentsSent" })}
        </div>
      )}
    </div>
  );
};

export default CustomerCard;
